(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.featured-collection--carousel').forEach(section => {
      const grid = section.querySelector('[data-featured-grid]');
      const prevBtn = section.querySelector('[data-featured-prev]');
      const nextBtn = section.querySelector('[data-featured-next]');

      if (!grid) return;

      const scrollAmount = () => {
        const item = grid.querySelector(':scope > *');
        if (!item) return 0;
        return item.offsetWidth + 20;
      };

      prevBtn?.addEventListener('click', () => {
        grid.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextBtn?.addEventListener('click', () => {
        grid.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header = document.getElementById('VFHeader');
    if (!header) return;

    const isTransparent = header.dataset.transparent === 'true';
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 60);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Cart count updater
    document.addEventListener('velvetfeel:cart:updated', (e) => {
      const badge = header.querySelector('.vf-header__cart-count');
      if (!badge) return;
      const count = e.detail?.count || 0;
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    });
      (function() {
    const header = document.getElementById('VFHeader');
    if (!header) return;

    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 60);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Cart count updater
    document.addEventListener('velvetfeel:cart:updated', (e) => {
      const badge = header.querySelector('.vf-header__cart-count');
      if (!badge) return;
      const count = e.detail?.count || 0;
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    });

    /* ===== MOBILE DRAWER ===== */
    const menuBtn = document.getElementById('VFMenuBtn');
    const drawer = document.getElementById('VFDrawer');
    const drawerClose = document.getElementById('VFDrawerClose');
    const overlay = document.getElementById('VFOverlay');

    function openDrawer() {
      drawer?.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.classList.add('vf-drawer-open');
      drawer?.setAttribute('aria-hidden', 'false');
      menuBtn?.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer?.classList.remove('is-open');
      overlay?.classList.remove('is-visible');
      document.body.classList.remove('vf-drawer-open');
      drawer?.setAttribute('aria-hidden', 'true');
      menuBtn?.setAttribute('aria-expanded', 'false');
      // Also collapse any expanded submenus
      drawer?.querySelectorAll('.vf-drawer__item--has-sub.is-expanded')
        .forEach(item => item.classList.remove('is-expanded'));
    }

    menuBtn?.addEventListener('click', openDrawer);
    drawerClose?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    // ESC key closes drawer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Submenu toggles inside drawer
    drawer?.querySelectorAll('[data-drawer-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.vf-drawer__item--has-sub');
        const isExpanded = item.classList.contains('is-expanded');

        // Close others (accordion behavior)
        drawer.querySelectorAll('.vf-drawer__item--has-sub.is-expanded')
          .forEach(other => {
            if (other !== item) other.classList.remove('is-expanded');
          });

        item.classList.toggle('is-expanded', !isExpanded);
        btn.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
      });
    });

  })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-vf-hero]').forEach(hero => {
      const slides = hero.querySelectorAll('.vf-hero__slide');
      const prev = hero.querySelector('[data-prev]');
      const next = hero.querySelector('[data-next]');
      const current = hero.querySelector('[data-current]');
      const progress = hero.querySelector('[data-progress]');
      const speed = 6500;

      if (slides.length <= 1) return;

      let idx = 0;
      let timer = null;

      function go(n) {
        slides[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');

        if (current) {
          current.textContent = String(idx + 1).padStart(2, '0');
        }

        resetProgress();
      }

      function resetProgress() {
        if (!progress) return;

        progress.style.transition = 'none';
        progress.style.width = '0%';

        requestAnimationFrame(() => {
          progress.style.transition = `width ${speed}ms linear`;
          progress.style.width = '100%';
        });
      }

      function start() {
        stop();
        resetProgress();
        timer = setInterval(() => go(idx + 1), speed);
      }

      function stop() {
        if (timer) clearInterval(timer);

        if (progress) {
          progress.style.transition = 'none';
          progress.style.width = '0%';
        }
      }

      prev?.addEventListener('click', () => {
        go(idx - 1);
        start();
      });

      next?.addEventListener('click', () => {
        go(idx + 1);
        start();
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      let startX = 0;

      hero.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX;
        stop();
      }, { passive: true });

      hero.addEventListener('touchend', e => {
        const d = startX - e.changedTouches[0].clientX;

        if (Math.abs(d) > 50) {
          go(d > 0 ? idx + 1 : idx - 1);
        }

        start();
      }, { passive: true });

      new IntersectionObserver(([e]) => {
        e.isIntersecting ? start() : stop();
      }).observe(hero);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.vf-collections');
    if (!section) return;

    const elements = section.querySelectorAll('.vf-collections__header, .vf-collection-card');
    if (elements.length === 0) return;

    // Fallback for browsers without IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(el => observer.observe(el));

    // Safety net: after 1s, force show anything still hidden
    setTimeout(() => {
      elements.forEach(el => {
        if (!el.classList.contains('is-visible')) {
          el.classList.add('is-visible');
        }
      });
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    const productSection = document.querySelector('[data-product-section]');
    if (!productSection) return;

    /* ===== GALLERY ===== */
    const slides = productSection.querySelectorAll('.vf-gallery__slide');
    const thumbs = productSection.querySelectorAll('.vf-gallery__thumb');
    const dots = productSection.querySelectorAll('.vf-gallery__dot');

    function showSlide(index) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => showSlide(i));
    });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => showSlide(i));
    });

    // Touch swipe on main image
    const galleryMain = productSection.querySelector('[data-gallery-main]');
    if (galleryMain) {
      let startX = 0, currentIndex = 0;
      galleryMain.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        slides.forEach((s, i) => { if (s.classList.contains('is-active')) currentIndex = i; });
      }, { passive: true });
      galleryMain.addEventListener('touchend', (e) => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          const newIndex = diff > 0
            ? Math.min(currentIndex + 1, slides.length - 1)
            : Math.max(currentIndex - 1, 0);
          showSlide(newIndex);
        }
      }, { passive: true });
    }

    /* ===== VARIANT PICKER ===== */
    const form = productSection.querySelector('[data-product-form]');
    const variantSelect = productSection.querySelector('[data-variant-select]');
    const optionInputs = productSection.querySelectorAll('[data-option-input]');
    const priceEl = productSection.querySelector('[data-price]');
    const comparePriceEl = productSection.querySelector('[data-compare-price]');
    const atcButton = productSection.querySelector('[data-atc-button]');
    const atcText = productSection.querySelector('[data-atc-text]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    function getSelectedOptions() {
      const options = [];
      productSection.querySelectorAll('.vf-option').forEach((opt) => {
        const checked = opt.querySelector('input:checked');
        if (checked) options.push(checked.value);
      });
      return options;
    }

    function findVariant(options) {
      return Array.from(variantSelect.options).find(opt => {
        const variant = Array.from(productSection.querySelectorAll('.vf-option')).every((optEl, i) => {
          const checked = optEl.querySelector('input:checked');
          return checked && opt.textContent.includes(checked.value);
        });
        return variant;
      });
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const variantOption = Array.from(variantSelect.options).find(opt => {
        const title = opt.textContent.trim();
        return selected.every(val => title.includes(val));
      });

      if (!variantOption) return;

      variantSelect.value = variantOption.value;
      const price = variantOption.dataset.price;
      const comparePrice = variantOption.dataset.comparePrice;
      const available = variantOption.dataset.available === 'true';

      if (priceEl) priceEl.textContent = price;
      if (comparePriceEl && comparePrice && comparePrice !== price) {
        comparePriceEl.textContent = comparePrice;
      }
      if (stickyPrice) stickyPrice.firstChild.textContent = price + ' ';

      if (atcButton) {
        atcButton.disabled = !available;
        if (atcText) atcText.textContent = available ? `Add to Bag — ${price}` : 'Sold Out';
      }

      // Update URL
      const url = new URL(window.location);
      url.searchParams.set('variant', variantOption.value);
      window.history.replaceState({}, '', url);
    }

    optionInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const optionEl = e.target.closest('.vf-option');
        const selectedSpan = optionEl.querySelector('[data-selected-value]');
        if (selectedSpan) selectedSpan.textContent = e.target.value;

        // Update active state
        optionEl.querySelectorAll('.vf-swatch, .vf-pill').forEach(el => {
          el.classList.toggle('is-active', el.contains(e.target) && e.target.checked);
        });
        e.target.closest('.vf-swatch, .vf-pill')?.classList.add('is-active');

        updateVariant();
      });
    });

    /* ===== QUANTITY ===== */
    const qtyInput = productSection.querySelector('[data-qty-input]');
    const qtyDec = productSection.querySelector('[data-qty-decrease]');
    const qtyInc = productSection.querySelector('[data-qty-increase]');

    qtyDec?.addEventListener('click', () => {
      const val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyInc?.addEventListener('click', () => {
      const val = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.min(val + 1, 99);
    });

    /* ===== ADD TO CART (AJAX) ===== */
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atcButton.disabled) return;

      const originalText = atcText.textContent;
      atcButton.disabled = true;
      atcText.textContent = 'Adding...';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) throw new Error('Add to cart failed');

        const cart = await fetch('/cart.js').then(r => r.json());
        document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
          detail: { count: cart.item_count, cart }
        }));

        atcText.textContent = '✓ Added!';
        setTimeout(() => {
          atcText.textContent = originalText;
          atcButton.disabled = false;
        }, 1800);

        // Open cart drawer if exists
        const cartDrawer = document.getElementById('CartDrawer');
        cartDrawer?.dispatchEvent(new CustomEvent('open'));

      } catch (err) {
        console.error(err);
        atcText.textContent = 'Try Again';
        setTimeout(() => {
          atcText.textContent = originalText;
          atcButton.disabled = false;
        }, 1800);
      }
    });

    /* ===== BUY NOW ===== */
    const buyNow = productSection.querySelector('[data-buynow]');
    buyNow?.addEventListener('click', async () => {
      const formData = new FormData(form);
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
        window.location.href = '/checkout';
      } catch (err) { console.error(err); }
    });

    /* ===== STICKY ATC ===== */
    const stickyBar = document.querySelector('[data-sticky-atc]');
    const stickyBtn = document.querySelector('[data-sticky-atc-button]');

    if (stickyBar && atcButton) {
      const observer = new IntersectionObserver(([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
      observer.observe(atcButton);

      stickyBtn?.addEventListener('click', () => atcButton.click());
    }

    /* ===== ZOOM LIGHTBOX ===== */
    const lightbox = document.querySelector('[data-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    const lightboxClose = lightbox?.querySelector('[data-lightbox-close]');
    const zoomBtns = productSection.querySelectorAll('[data-zoom-trigger]');

    zoomBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const img = btn.querySelector('img');
        if (!img) return;
        lightboxImage.innerHTML = `<img src="${img.src.replace(/_\d+x/, '_1600x')}" alt="${img.alt}">`;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lightboxImage.innerHTML = '';
    }
    lightboxClose?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox?.classList.contains('is-open')) closeLightbox();
    });

    /* ===== DELIVERY CHECKER ===== */
    const deliveryForm = productSection.querySelector('[data-delivery-form]');
    const pincodeInput = productSection.querySelector('[data-pincode-input]');
    const deliveryResult = productSection.querySelector('[data-delivery-result]');

    deliveryForm?.addEventListener('submit', (e) => {
      e.preventDefault();
      const pin = pincodeInput.value.trim();
      if (pin.length !== 6) {
        deliveryResult.textContent = '⚠ Please enter a valid 6-digit PIN code';
        deliveryResult.style.color = '#B23838';
        return;
      }
      const days = Math.floor(Math.random() * 4) + 3;
      const date = new Date();
      date.setDate(date.getDate() + days);
      const formatted = date.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      deliveryResult.textContent = `✓ Delivery by ${formatted} · Free shipping above ₹999`;
      deliveryResult.style.color = '#2D6A4F';
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.vf-news__form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        try {
          await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/javascript' }
          });
          form.style.display = 'none';
          const success = form.parentElement.querySelector('.vf-news__success');
          if (success) { success.hidden = false; success.setAttribute('data-show', ''); }
        } catch (err) { console.error(err); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const faqSection = document.querySelector('.vf-faq');
    if (!faqSection) return;

    const searchInput = faqSection.querySelector('[data-faq-search]');
    const tabs = faqSection.querySelectorAll('.vf-faq__tab');
    const items = faqSection.querySelectorAll('[data-faq-item]');
    const emptyMsg = faqSection.querySelector('[data-faq-empty]');

    let activeCategory = 'all';
    let searchQuery = '';

    function filterItems() {
      let visibleCount = 0;

      items.forEach(item => {
        const category = item.dataset.category;
        const question = item.querySelector('.vf-faq__question-text')?.textContent.toLowerCase() || '';
        const answer = item.querySelector('.vf-faq__answer')?.textContent.toLowerCase() || '';

        const matchesCategory = activeCategory === 'all' || category === activeCategory;
        const matchesSearch = !searchQuery ||
          question.includes(searchQuery) ||
          answer.includes(searchQuery);

        if (matchesCategory && matchesSearch) {
          item.hidden = false;
          visibleCount++;
        } else {
          item.hidden = true;
          item.removeAttribute('open');
        }
      });

      if (emptyMsg) {
        emptyMsg.hidden = visibleCount > 0;
      }
    }

    /* Search */
    if (searchInput) {
      let debounce;
      searchInput.addEventListener('input', (e) => {
        clearTimeout(debounce);
        debounce = setTimeout(() => {
          searchQuery = e.target.value.trim().toLowerCase();
          filterItems();
        }, 200);
      });
    }

    /* Category tabs */
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        activeCategory = tab.dataset.category;
        filterItems();
      });
    });

    /* Optional: only one open at a time */
    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (item.open && faqSection.dataset.singleOpen === 'true') {
          items.forEach(other => {
            if (other !== item) other.removeAttribute('open');
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-404"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-vf404-reveal]').forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const els = document.querySelectorAll('.vf404 [data-vf404-reveal]:not(.is-revealed)');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = parseInt(entry.target.dataset.vf404Delay) || 0;
          setTimeout(() => entry.target.classList.add('is-revealed'), delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-about"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!('IntersectionObserver' in window)) return;
    const els = document.querySelectorAll('.vfa [data-vfa-reveal]:not(.is-revealed)');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = parseInt(entry.target.dataset.vfaDelay) || 0;
          setTimeout(() => entry.target.classList.add('is-revealed'), delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(el => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-account-dashboard"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfdash [data-vfdash-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfdashDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-account-login"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const loginPanel = document.getElementById('LoginPanel');
    const recoverPanel = document.getElementById('RecoverPanel');
    const showRecover = document.getElementById('ShowRecover');
    const backToLogin = document.getElementById('BackToLogin');

    if (showRecover) showRecover.addEventListener('click', function(e) {
      e.preventDefault();
      loginPanel.hidden = true;
      recoverPanel.hidden = false;
      window.location.hash = 'recover';
    });

    if (backToLogin) backToLogin.addEventListener('click', function(e) {
      e.preventDefault();
      loginPanel.hidden = false;
      recoverPanel.hidden = true;
      window.location.hash = 'login';
    });

    // Check URL hash on load
    if (window.location.hash === '#recover') {
      loginPanel.hidden = true;
      recoverPanel.hidden = false;
    }

    // Reveal
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfac [data-vfac-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfacDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-account-register"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfac [data-vfac-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfacDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-activate-account"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfac [data-vfac-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfacDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-addresses"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-vfaddr-section]');
    if (!section) return;

    // Toggle new address form
    const newForm = document.getElementById('NewAddressForm');
    section.querySelectorAll('[data-toggle-new-form]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (newForm) {
          newForm.hidden = !newForm.hidden;
          if (!newForm.hidden) {
            newForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    });

    // Toggle edit forms
    section.querySelectorAll('[data-toggle-edit-form]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.toggleEditForm;
        const form = document.getElementById('EditAddress' + id);
        if (form) {
          form.hidden = !form.hidden;
          if (!form.hidden) {
            form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    });

    // Delete address with confirmation
    section.querySelectorAll('[data-delete-address]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (confirm('Are you sure you want to delete this address?')) {
          const url = btn.dataset.deleteAddress;
          fetch(url, { method: 'DELETE', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(() => location.reload())
            .catch(err => console.error(err));
        }
      });
    });

    // Country/Province selector for new address form
    function initCountrySelector(countrySelect, provinceSelect, countryInput, provinceInput) {
      if (!countrySelect || !provinceSelect) return;

      function updateProvinces() {
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        const provincesData = selectedOption?.dataset?.provinces;
        provinceSelect.innerHTML = '';

        if (provincesData) {
          try {
            const provinces = JSON.parse(provincesData);
            if (provinces.length > 0) {
              provinces.forEach(([code, name]) => {
                const opt = document.createElement('option');
                opt.value = name;
                opt.textContent = name;
                opt.dataset.code = code;
                provinceSelect.appendChild(opt);
              });
              provinceSelect.disabled = false;
            } else {
              const opt = document.createElement('option');
              opt.value = '';
              opt.textContent = 'No states/provinces';
              provinceSelect.appendChild(opt);
              provinceSelect.disabled = true;
            }
          } catch (e) {
            provinceSelect.disabled = true;
          }
        }

        if (countryInput) countryInput.value = countrySelect.value;
        if (provinceInput) provinceInput.value = provinceSelect.value;
      }

      countrySelect.addEventListener('change', updateProvinces);
      provinceSelect.addEventListener('change', () => {
        if (provinceInput) provinceInput.value = provinceSelect.value;
      });

      // Set default to India if available
      const indiaOption = Array.from(countrySelect.options).find(o =>
        o.value === 'India' || o.value === 'IN'
      );
      if (indiaOption && !countrySelect.value) {
        countrySelect.value = indiaOption.value;
      }

      updateProvinces();
    }

    // Init new form selectors
    initCountrySelector(
      section.querySelector('[data-country-select]'),
      section.querySelector('[data-province-select]')
    );

    // Init edit form selectors
    section.querySelectorAll('.vfaddr-card__edit-form').forEach(form => {
      const cs = form.querySelector('[data-edit-country-select]');
      const ps = form.querySelector('[data-edit-province-select]');
      const ci = form.querySelector('[data-edit-country-input]');
      const pi = form.querySelector('[data-edit-province-input]');

      if (cs && ci.value) {
        cs.value = Array.from(cs.options).find(o => o.value === ci.value || o.value === ci.dataset.country)?.value || cs.value;
      }
      initCountrySelector(cs, ps, ci, pi);
      if (ps && pi.value) {
        ps.value = pi.value;
      }
    });

    // Reveal
    if ('IntersectionObserver' in window) {
      const els = section.querySelectorAll('[data-vfaddr-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfaddrDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-article"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Reveal animations
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfart [data-vfart-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfartDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
      els.forEach(el => io.observe(el));
    }

    // Copy link
    const copyBtn = document.querySelector('[data-copy-link]');
    const copyFeedback = document.querySelector('[data-copy-feedback]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        const url = window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            if (copyFeedback) {
              copyFeedback.classList.add('is-visible');
              setTimeout(() => copyFeedback.classList.remove('is-visible'), 2000);
            }
          });
        } else {
          // Fallback
          const input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          if (copyFeedback) {
            copyFeedback.classList.add('is-visible');
            setTimeout(() => copyFeedback.classList.remove('is-visible'), 2000);
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-blog"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfblog [data-vfblog-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfblogDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-cart"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-vfcart-section]');
    if (!section) return;

    let updateTimer = null;

    function debounce(fn, delay) {
      return function(...args) {
        clearTimeout(updateTimer);
        updateTimer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    async function updateCart(key, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    const cart = await res.json();
    document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
      detail: { count: cart.item_count, cart: cart }
    }));

    // If cart empty, reload to show empty state
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update totals
    const subtotalEl = section.querySelector('[data-cart-subtotal]');
    const totalEl = section.querySelector('[data-cart-total]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Update line totals
    cart.items.forEach((item, idx) => {
      const line = section.querySelector(`[data-line="${idx + 1}"]`);
      if (line) {
        const lineTotal = line.querySelector('[data-line-total]');
        if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price);
      }
    });

    // ===== UPDATE SHIPPING BAR (NEW) =====
    updateShippingBar(cart.total_price);

    // ===== UPDATE HEADER COUNT (NEW) =====
    updateCartCountText(cart.item_count);

  } catch (err) {
    console.error('[VF Cart Page] Update failed:', err);
    location.reload();
  }
}

// ===== NEW FUNCTION: Update shipping bar =====
function updateShippingBar(totalPrice) {
  const THRESHOLD = 249900; // ₹2,499 in paise
  const remaining = Math.max(0, THRESHOLD - totalPrice);
  let progress = (totalPrice / THRESHOLD) * 100;
  if (progress > 100) progress = 100;

  const shippingContainer = section.querySelector('.vfcart__shipping');
  const progressFill = section.querySelector('.vfcart__progress-fill');
  const shippingText = section.querySelector('.vfcart__shipping-text');

  // Update progress bar width
  if (progressFill) {
    progressFill.style.width = progress + '%';
  }

  // Update text message
  if (shippingText) {
    if (remaining > 0) {
      shippingText.className = 'vfcart__shipping-text';
      shippingText.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> for complimentary discreet shipping';
    } else {
      shippingText.className = 'vfcart__shipping-text vfcart__shipping-text--unlocked';
      shippingText.innerHTML = '<span class="vfcart__shipping-icon">✦</span> Complimentary discreet shipping unlocked';
    }
  }

  // Update shipping row in summary
  const shipRow = section.querySelector('.vfcart__summary-row--ship span:last-child');
  if (shipRow) {
    if (remaining > 0) {
      shipRow.innerHTML = 'Calculated at checkout';
    } else {
      shipRow.innerHTML = '<em>Free</em>';
    }
  }
}

// ===== NEW FUNCTION: Update header cart count =====
function updateCartCountText(count) {
  // Update page title count
  const titleCount = section.querySelector('.vfcart__count');
  if (titleCount) {
    titleCount.textContent = '(' + count + ')';
  }

  // Update header badges everywhere
  const badges = document.querySelectorAll('#CartCount, .vf-header__cart-count, [data-cart-count]');
  badges.forEach(b => {
    if (count > 0) {
      b.textContent = count > 99 ? '99+' : count;
      b.removeAttribute('hidden');
      b.style.display = '';
    } else {
      b.setAttribute('hidden', '');
      b.style.display = 'none';
    }
  });
}

    // Quantity buttons
    section.addEventListener('click', (e) => {
      const inc = e.target.closest('[data-cart-inc]');
      const dec = e.target.closest('[data-cart-dec]');
      const rem = e.target.closest('[data-cart-remove]');

      if (!inc && !dec && !rem) return;
      e.preventDefault();

      const item = e.target.closest('[data-cart-line]');
      if (!item) return;
      const key = item.dataset.lineKey;
      const input = item.querySelector('[data-cart-input]');
      let qty = parseInt(input.value) || 1;

      if (inc) qty++;
      if (dec) qty = Math.max(0, qty - 1);
      if (rem) qty = 0;

      input.value = qty;

      if (qty === 0) item.classList.add('is-removing');

      updateCart(key, qty);
    });

    // Direct input change
    section.addEventListener('input', debounce((e) => {
      const input = e.target.closest('[data-cart-input]');
      if (!input) return;

      const item = input.closest('[data-cart-line]');
      const key = item.dataset.lineKey;
      const qty = parseInt(input.value) || 0;

      if (qty === 0) item.classList.add('is-removing');
      updateCart(key, qty);
    }, 500));

    // Notes
    const noteInput = section.querySelector('[data-cart-note]');
    if (noteInput) {
      let noteTimer = null;
      noteInput.addEventListener('input', () => {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(async () => {
          try {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteInput.value })
            });
          } catch (err) { console.error(err); }
        }, 600);
      });
    }

    // Discount
    const discountForm = section.querySelector('[data-discount-form]');
    const discountInput = section.querySelector('[data-discount-input]');
    const discountResult = section.querySelector('[data-discount-result]');

    if (discountForm) {
      discountForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const code = discountInput.value.trim();
        if (!code) return;

        discountResult.textContent = 'Applying...';
        discountResult.className = 'vfcart__discount-result';

        try {
          const res = await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
          if (res.ok || res.redirected) {
            discountResult.textContent = '✓ Code "' + code + '" will apply at checkout';
            discountResult.classList.add('is-success');
            sessionStorage.setItem('vf_discount', code);
          } else {
            throw new Error('Invalid');
          }
        } catch (err) {
          discountResult.textContent = '✕ Invalid or expired code';
          discountResult.classList.add('is-error');
        }
      });
    }

    // Apply discount on checkout
    const checkoutBtn = section.querySelector('.vfcart__checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', (e) => {
        const code = sessionStorage.getItem('vf_discount');
        if (code) {
          e.preventDefault();
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
        }
      });
    }

    // Reveal animations
    if ('IntersectionObserver' in window) {
      const els = section.querySelectorAll('[data-vfcart-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfcartDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // ===== REVEAL ON SCROLL =====
    const reveals = document.querySelectorAll('.vfgrid [data-vfgrid-reveal]:not(.is-revealed)');
    if (!reveals.length) return;

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfgridDelay) || 0;
            setTimeout(() => {
              entry.target.classList.add('is-revealed');
            }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

      reveals.forEach(el => io.observe(el));
    } else {
      reveals.forEach(el => el.classList.add('is-revealed'));
    }

    // ===== QUICK ADD =====
    document.querySelectorAll('.vfgrid [data-vfgrid-add]').forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const textEl = this.querySelector('.vfgrid-card__cta-text');
        const original = textEl?.textContent || 'Add to Bag';
        if (textEl) textEl.textContent = 'Adding...';
        this.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });

          if (!res.ok) throw new Error('Add failed');

          const cart = await fetch('/cart.js').then(r => r.json());
          document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
            detail: { count: cart.item_count, cart }
          }));

          if (textEl) textEl.textContent = '✓ Added';
          setTimeout(() => {
            if (textEl) textEl.textContent = original;
            this.disabled = false;
          }, 1800);

        } catch (err) {
          console.error('Velvetfeel cart error:', err);
          if (textEl) textEl.textContent = 'Try Again';
          setTimeout(() => {
            if (textEl) textEl.textContent = original;
            this.disabled = false;
          }, 1500);
        }
      });
    });

    // ===== WISHLIST =====
    document.querySelectorAll('.vfgrid [data-vfgrid-wish]').forEach(btn => {
      const handle = btn.dataset.handle;
      if (!handle) return;

      // Load saved state
      try {
        const saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
        if (saved.includes(handle)) btn.classList.add('is-saved');
      } catch(e) {}

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        try {
          let saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
          if (saved.includes(handle)) {
            saved = saved.filter(h => h !== handle);
            btn.classList.remove('is-saved');
          } else {
            saved.push(handle);
            btn.classList.add('is-saved');
          }
          localStorage.setItem('vf_wishlist', JSON.stringify(saved));
          document.dispatchEvent(new CustomEvent('velvetfeel:wishlist:updated', {
            detail: { count: saved.length }
          }));
        } catch(err) { console.error(err); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-collection"]) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-vfcol-section]');
    if (!section) return;

    // Reveal on scroll
    const cards = section.querySelectorAll('.vfcol-card');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('is-revealed'), i * 50);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
      cards.forEach(c => io.observe(c));
    } else {
      cards.forEach(c => c.classList.add('is-revealed'));
    }

    // Sort
    const sortSelect = section.querySelector('[data-sort-select]');
    sortSelect?.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });

    // Filter drawer
    const filterDrawer = document.querySelector('[data-filter-drawer]');
    const openBtn = section.querySelector('[data-filter-open]');

    openBtn?.addEventListener('click', () => {
      filterDrawer?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    filterDrawer?.querySelectorAll('[data-filter-close]').forEach(el => {
      el.addEventListener('click', () => {
        filterDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Update filter count
    function updateFilterCount() {
      const count = filterDrawer?.querySelectorAll('input:checked').length || 0;
      const badge = section.querySelector('[data-active-filter-count]');
      if (badge) {
        if (count > 0) {
          badge.textContent = count;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    }
    updateFilterCount();

    // Wishlist
    section.querySelectorAll('.vfcol-card__wish').forEach(btn => {
      const handle = btn.dataset.handle;
      try {
        const saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
        if (saved.includes(handle)) btn.classList.add('is-saved');
      } catch(e) {}

      btn.addEventListener('click', () => {
        try {
          let saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
          if (saved.includes(handle)) {
            saved = saved.filter(h => h !== handle);
            btn.classList.remove('is-saved');
          } else {
            saved.push(handle);
            btn.classList.add('is-saved');
          }
          localStorage.setItem('vf_wishlist', JSON.stringify(saved));
        } catch(err) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-contact"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!('IntersectionObserver' in window)) return;
    const els = document.querySelectorAll('.vfct [data-vfct-reveal]:not(.is-revealed)');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = parseInt(entry.target.dataset.vfctDelay) || 0;
          setTimeout(() => entry.target.classList.add('is-revealed'), delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(el => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-order"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vford [data-vford-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfordDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfpage [data-vfpage-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfpageDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-product"]) return;
  try {
    
  (function() {
    'use strict';
    console.log('[VF Product] Initializing...');

    const section = document.querySelector('[data-vfp-section]');
    if (!section) {
      console.warn('[VF Product] Section not found');
      return;
    }

    // GALLERY
    const slides = section.querySelectorAll('.vfp__slide');
    const thumbs = section.querySelectorAll('.vfp__thumb');
    const dots = section.querySelectorAll('.vfp__dot');
    const progress = section.querySelector('[data-gallery-progress]');
    const prevBtn = section.querySelector('[data-gallery-prev]');
    const nextBtn = section.querySelector('[data-gallery-next]');

    let currentIdx = 0;
    let timer = null;
    const autoplay = section.dataset.autoplay === 'true';
    const speed = (parseInt(section.dataset.autoplaySpeed) || 5) * 1000;

    function showSlide(i) {
      currentIdx = (i + slides.length) % slides.length;
      slides.forEach(function(s, idx) { s.classList.toggle('is-active', idx === currentIdx); });
      thumbs.forEach(function(t, idx) { t.classList.toggle('is-active', idx === currentIdx); });
      dots.forEach(function(d, idx) { d.classList.toggle('is-active', idx === currentIdx); });
      resetProgress();
    }

    function resetProgress() {
      if (!progress) return;
      progress.style.transition = 'none';
      progress.style.width = '0%';
      requestAnimationFrame(function() {
        progress.style.transition = 'width ' + speed + 'ms linear';
        progress.style.width = '100%';
      });
    }

    function startAuto() {
      if (!autoplay || slides.length <= 1) return;
      stopAuto();
      resetProgress();
      timer = setInterval(function() { showSlide(currentIdx + 1); }, speed);
    }

    function stopAuto() {
      if (timer) clearInterval(timer);
      if (progress) { progress.style.transition = 'none'; progress.style.width = '0%'; }
    }

    thumbs.forEach(function(t, i) { t.addEventListener('click', function() { showSlide(i); startAuto(); }); });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { showSlide(i); startAuto(); }); });
    if (prevBtn) prevBtn.addEventListener('click', function() { showSlide(currentIdx - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { showSlide(currentIdx + 1); startAuto(); });

    const main = section.querySelector('.vfp__main');
    if (main) {
      main.addEventListener('mouseenter', stopAuto);
      main.addEventListener('mouseleave', startAuto);
      let startX = 0;
      main.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; stopAuto(); }, { passive: true });
      main.addEventListener('touchend', function(e) {
        const d = startX - e.changedTouches[0].clientX;
        if (Math.abs(d) > 50) showSlide(d > 0 ? currentIdx + 1 : currentIdx - 1);
        startAuto();
      }, { passive: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        entries.forEach(function(e) { e.isIntersecting ? startAuto() : stopAuto(); });
      }).observe(section);
    }
    startAuto();

    // VARIANTS
    const form = section.querySelector('[data-product-form]');
    const variantSelect = section.querySelector('[data-variant-select]');
    const inputs = section.querySelectorAll('[data-vfp-input]');
    const priceEl = section.querySelector('[data-price]');
    const compareEl = section.querySelector('[data-compare]');
    const atcBtn = section.querySelector('[data-atc]');
    const atcText = section.querySelector('[data-atc-text]');
    const stickyPrice = document.querySelector('[data-sticky-price]');

    function updateVariant() {
      if (!variantSelect) return;
      const selected = [];
      section.querySelectorAll('.vfp-opt').forEach(function(opt) {
        const checked = opt.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      if (selected.length === 0) return;

      const match = Array.from(variantSelect.options).find(function(o) {
        return selected.every(function(v) { return o.textContent.includes(v); });
      });
      if (!match) return;

      variantSelect.value = match.value;
      const price = match.dataset.price;
      const compare = match.dataset.comparePrice;
      const available = match.dataset.available === 'true';

      if (priceEl) priceEl.textContent = price;
      if (compareEl && compare && compare !== price) compareEl.textContent = compare;
      if (stickyPrice) stickyPrice.textContent = price;
      if (atcBtn) {
        atcBtn.disabled = !available;
        if (atcText) atcText.textContent = available ? 'Add to Bag' : 'Sold Out';
      }
    }

    inputs.forEach(function(input) {
      input.addEventListener('change', function(e) {
        const opt = e.target.closest('.vfp-opt');
        const sel = opt.querySelector('[data-selected]');
        if (sel) sel.textContent = e.target.value;
        opt.querySelectorAll('.vfp-swatch, .vfp-pill').forEach(function(el) {
          el.classList.toggle('is-active', el.contains(e.target));
        });
        updateVariant();
      });
    });

    // QUANTITY
    const qtyInput = section.querySelector('[data-qty-input]');
    const qtyDec = section.querySelector('[data-qty-dec]');
    const qtyInc = section.querySelector('[data-qty-inc]');
    if (qtyDec) qtyDec.addEventListener('click', function() {
      const v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (qtyInc) qtyInc.addEventListener('click', function() {
      const v = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.min(v + 1, 99);
    });

    // ===== ADD TO CART (FIXED) =====
    // ===== ADD TO CART (BULLETPROOF) =====
if (form) {
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    if (atcBtn && atcBtn.disabled) return;

    const original = atcText ? atcText.textContent : 'Add to Bag';
    if (atcBtn) atcBtn.disabled = true;
    if (atcText) atcText.textContent = 'Adding...';

    try {
      // Try multiple ways to get the variant ID
      let variantId = null;

      // Method 1: From the data-variant-select element
      if (variantSelect && variantSelect.value) {
        variantId = variantSelect.value;
      }

      // Method 2: Find any input/select with name="id" inside the form
      if (!variantId) {
        const idField = form.querySelector('[name="id"]');
        if (idField && idField.value) {
          variantId = idField.value;
        }
      }

      // Method 3: Use the product's first available variant ID (fallback)
      if (!variantId) {
        const allOptions = variantSelect ? variantSelect.querySelectorAll('option') : [];
        for (let i = 0; i < allOptions.length; i++) {
          if (allOptions[i].dataset.available === 'true') {
            variantId = allOptions[i].value;
            break;
          }
        }
      }

      const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      console.log('[VF Product] Attempting add:', {
        variantId: variantId,
        variantSelectExists: !!variantSelect,
        variantSelectValue: variantSelect ? variantSelect.value : 'N/A',
        formIdField: form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : 'N/A',
        quantity: quantity
      });

      if (!variantId) {
        throw new Error('No variant available. Please refresh and try again.');
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: quantity
          }]
        })
      });

      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch(err) {
        console.error('[VF Product] Response not JSON:', text);
        throw new Error('Server error');
      }

      if (!res.ok) {
        console.error('[VF Product] Cart add failed:', data);
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      console.log('[VF Product] ✓ Added successfully', data);

      // Get fresh cart
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await cartRes.json();

      // Notify
      document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
        detail: { count: cart.item_count, cart: cart }
      }));

      // Open drawer
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('velvetfeel:cart:open'));
      }, 300);

      if (atcText) atcText.textContent = '✓ Added to Bag';
      setTimeout(function() {
        if (atcText) atcText.textContent = original;
        if (atcBtn) atcBtn.disabled = false;
      }, 1800);

    } catch (err) {
      console.error('[VF Product] Cart error:', err);
      if (atcText) atcText.textContent = 'Try Again';
      setTimeout(function() {
        if (atcText) atcText.textContent = original;
        if (atcBtn) atcBtn.disabled = false;
      }, 2500);
    }
  });
}

    // BUY NOW
    const buyNow = section.querySelector('[data-buynow]');
    if (buyNow) {
      buyNow.addEventListener('click', async function() {
        try {
          const variantId = variantSelect ? variantSelect.value : null;
          const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

          if (!variantId) {
            alert('Please select options');
            return;
          }

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId), quantity: quantity }]
            })
          });

          window.location.href = '/checkout';
        } catch (err) {
          console.error('[VF Product] Buy Now failed:', err);
        }
      });
    }

    // STICKY ATC
    const stickyBar = document.querySelector('[data-sticky-atc]');
    const stickyBtn = document.querySelector('[data-sticky-add]');
    if (stickyBar && atcBtn) {
      new IntersectionObserver(function(entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: '0px 0px -100px 0px' }).observe(atcBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function() { atcBtn.click(); });
    }

    // LIGHTBOX
    const lightbox = document.querySelector('[data-lightbox]');
    const lbContent = lightbox && lightbox.querySelector('[data-lightbox-content]');
    const lbClose = lightbox && lightbox.querySelector('[data-lightbox-close]');

    section.querySelectorAll('[data-zoom-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const img = btn.querySelector('img');
        if (!img || !lbContent) return;
        lbContent.innerHTML = '<img src="' + img.src.replace(/_\d+x/, '_1600x') + '" alt="' + img.alt + '">';
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeLightbox() {
      if (lightbox) lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lbContent) lbContent.innerHTML = '';
    }
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function(e) { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) closeLightbox();
    });

    // WISHLIST
    const wishBtn = section.querySelector('[data-wish]');
    if (wishBtn) {
      const handle = wishBtn.dataset.handle;
      try {
        const saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
        if (saved.includes(handle)) wishBtn.classList.add('is-saved');
      } catch (e) {}

      wishBtn.addEventListener('click', function() {
        try {
          let saved = JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
          if (saved.includes(handle)) {
            saved = saved.filter(function(h) { return h !== handle; });
            wishBtn.classList.remove('is-saved');
          } else {
            saved.push(handle);
            wishBtn.classList.add('is-saved');
          }
          localStorage.setItem('vf_wishlist', JSON.stringify(saved));
        } catch (err) {}
      });
    }

    // DELIVERY
    const pinCheckBtn = section.querySelector('[data-pin-check]');
    const pin = section.querySelector('[data-pin]');
    const dResult = section.querySelector('[data-delivery-result]');

    function checkPin() {
      const code = pin.value.trim();
      if (code.length !== 6) {
        dResult.textContent = 'Please enter a valid 6-digit PIN';
        return;
      }
      const days = Math.floor(Math.random() * 4) + 3;
      const date = new Date();
      date.setDate(date.getDate() + days);
      const formatted = date.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
      dResult.textContent = 'Expected delivery by ' + formatted + ' · Free shipping above ₹2,499';
    }

    if (pinCheckBtn) pinCheckBtn.addEventListener('click', checkPin);
    if (pin) pin.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); checkPin(); }
    });

    console.log('[VF Product] Ready ✓');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-vfrv-section]');
    if (!section) return;

    const scrollEl = section.querySelector('[data-rv-scroll]');
    const currentHandle = section.dataset.currentHandle;
    const STORAGE_KEY = 'vf_recently_viewed';
    const MAX_ITEMS = 12;

    function getViewed() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) { return []; }
    }

    function saveViewed(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    }

    function addToViewed(handle) {
      let list = getViewed();
      list = list.filter(h => h !== handle); // Remove if exists
      list.unshift(handle); // Add to top
      saveViewed(list);
    }

    async function fetchProduct(handle) {
      try {
        const res = await fetch('/products/' + handle + '.js');
        if (!res.ok) return null;
        return await res.json();
      } catch (e) { return null; }
    }

    function formatPrice(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    function renderCard(product, index) {
      const card = document.createElement('a');
      card.className = 'vfrv-card';
      card.href = '/products/' + product.handle;
      card.style.animationDelay = (index * 60) + 'ms';
      card.innerHTML = `
        <div class="vfrv-card__media">
          ${product.featured_image ? `<img class="vfrv-card__img" src="${product.featured_image}" alt="${product.title}" loading="lazy">` : ''}
        </div>
        ${product.vendor ? `<p class="vfrv-card__vendor">${product.vendor}</p>` : ''}
        <h3 class="vfrv-card__title">${product.title}</h3>
        <p class="vfrv-card__price">${formatPrice(product.price)}</p>
      `;
      return card;
    }

    async function render() {
      let viewedHandles = getViewed();

      // Exclude current product
      if (currentHandle) {
        viewedHandles = viewedHandles.filter(h => h !== currentHandle);
      }

      if (viewedHandles.length === 0) {
        section.hidden = true;
        return;
      }

      const products = await Promise.all(viewedHandles.slice(0, 8).map(fetchProduct));
      const valid = products.filter(p => p !== null);

      if (valid.length === 0) {
        section.hidden = true;
        return;
      }

      scrollEl.innerHTML = '';
      valid.forEach((product, i) => {
        scrollEl.appendChild(renderCard(product, i));
      });

      section.hidden = false;
    }

    // Track current product view
    if (currentHandle) {
      addToViewed(currentHandle);
    }

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-reset-password"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfac [data-vfac-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfacDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-search"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if ('IntersectionObserver' in window) {
      const els = document.querySelectorAll('.vfsr [data-vfsr-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfsrDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(el => io.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-vfwish-section]');
    if (!section) return;

    const emptyEl = section.querySelector('[data-wishlist-empty]');
    const loadingEl = section.querySelector('[data-wishlist-loading]');
    const gridEl = section.querySelector('[data-wishlist-grid]');
    const ctaEl = section.querySelector('[data-wishlist-cta]');
    const countEl = section.querySelector('[data-wishlist-count]');
    const pluralEl = section.querySelector('[data-wishlist-plural]');

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem('vf_wishlist') || '[]');
      } catch (e) { return []; }
    }

    function saveWishlist(list) {
      localStorage.setItem('vf_wishlist', JSON.stringify(list));
      document.dispatchEvent(new CustomEvent('velvetfeel:wishlist:updated', {
        detail: { count: list.length }
      }));
    }

    function updateCount(count) {
      if (countEl) countEl.textContent = count;
      if (pluralEl) pluralEl.textContent = count === 1 ? '' : 's';
    }

    async function fetchProduct(handle) {
      try {
        const res = await fetch('/products/' + handle + '.js');
        if (!res.ok) return null;
        return await res.json();
      } catch (e) { return null; }
    }

    function formatPrice(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderCard(product) {
      const onSale = product.compare_at_price && product.compare_at_price > product.price;
      const variant = product.variants.find(v => v.available) || product.variants[0];

      const card = document.createElement('article');
      card.className = 'vfwish-card';
      card.dataset.handle = product.handle;

      card.innerHTML = `
        <div class="vfwish-card__media">
          ${onSale ? `<span class="vfwish-card__badge">Sale</span>` : ''}
          <button type="button" class="vfwish-card__remove" aria-label="Remove from wishlist" data-wish-remove>
            <svg viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          </button>
          <a href="/products/${product.handle}" class="vfwish-card__link">
            ${product.featured_image ? `<img class="vfwish-card__img" src="${product.featured_image}" alt="${product.title}" loading="lazy">` : ''}
          </a>
        </div>
        <div class="vfwish-card__info">
          ${product.vendor ? `<p class="vfwish-card__vendor">${product.vendor}</p>` : ''}
          <a href="/products/${product.handle}" class="vfwish-card__title">${product.title}</a>
          <div class="vfwish-card__price">
            <span class="vfwish-card__price-now">${formatPrice(product.price)}</span>
            ${onSale ? `<span class="vfwish-card__price-was">${formatPrice(product.compare_at_price)}</span>` : ''}
          </div>
        </div>
        <button type="button" class="vfwish-card__add" data-wish-add data-variant-id="${variant ? variant.id : ''}" ${!variant || !variant.available ? 'disabled' : ''}>
          <span>${!variant || !variant.available ? 'Sold Out' : 'Add to Bag'}</span>
          ${variant && variant.available ? '<svg viewBox="0 0 32 12" fill="none"><path d="M0 6h30M24 1l6 5-6 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : ''}
        </button>
      `;

      return card;
    }

    async function render() {
      const handles = getWishlist();
      updateCount(handles.length);

      if (handles.length === 0) {
        emptyEl.hidden = false;
        loadingEl.hidden = true;
        gridEl.hidden = true;
        ctaEl.hidden = true;
        return;
      }

      emptyEl.hidden = true;
      loadingEl.hidden = false;
      gridEl.hidden = true;
      ctaEl.hidden = true;

      const products = await Promise.all(handles.map(fetchProduct));
      const validProducts = products.filter(p => p !== null);

      // Clean up wishlist if any products were removed/deleted
      if (validProducts.length !== handles.length) {
        const validHandles = validProducts.map(p => p.handle);
        saveWishlist(validHandles);
        updateCount(validHandles.length);
      }

      loadingEl.hidden = true;

      if (validProducts.length === 0) {
        emptyEl.hidden = false;
        return;
      }

      gridEl.innerHTML = '';
      validProducts.forEach((product, i) => {
        const card = renderCard(product);
        card.style.animationDelay = (i * 80) + 'ms';
        gridEl.appendChild(card);
      });
      gridEl.hidden = false;
      ctaEl.hidden = false;
    }

    // Remove from wishlist
    gridEl.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('[data-wish-remove]');
      const addBtn = e.target.closest('[data-wish-add]');

      if (removeBtn) {
        const card = removeBtn.closest('.vfwish-card');
        const handle = card.dataset.handle;
        card.classList.add('is-removing');

        setTimeout(() => {
          let list = getWishlist();
          list = list.filter(h => h !== handle);
          saveWishlist(list);
          card.remove();
          updateCount(list.length);

          if (list.length === 0) {
            gridEl.hidden = true;
            ctaEl.hidden = true;
            emptyEl.hidden = false;
          }
        }, 400);
      }

      if (addBtn && !addBtn.disabled) {
        const variantId = addBtn.dataset.variantId;
        if (!variantId) return;

        const originalText = addBtn.querySelector('span').textContent;
        addBtn.disabled = true;
        addBtn.querySelector('span').textContent = 'Adding...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId), quantity: 1 }]
            })
          });

          if (!res.ok) throw new Error('Failed');

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('velvetfeel:cart:updated', {
            detail: { count: cart.item_count, cart: cart }
          }));

          addBtn.querySelector('span').textContent = '✓ Added';
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('velvetfeel:cart:open'));
            addBtn.querySelector('span').textContent = originalText;
            addBtn.disabled = false;
          }, 1200);
        } catch (err) {
          addBtn.querySelector('span').textContent = 'Try Again';
          setTimeout(() => {
            addBtn.querySelector('span').textContent = originalText;
            addBtn.disabled = false;
          }, 1500);
        }
      }
    });

    // Reveal animations
    if ('IntersectionObserver' in window) {
      const els = section.querySelectorAll('[data-vfwish-reveal]:not(.is-revealed)');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.vfwishDelay) || 0;
            setTimeout(() => entry.target.classList.add('is-revealed'), delay);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(el => io.observe(el));
    }

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
